/* eslint-disable */
const { OKTA_CLIENT_ID, OKTA_ISSUER, OKTA_TESTING_DISABLEHTTPSCHECK, OKTA_REDIRECT_URL } = process.env;
export default {
  oidc: {
    clientId: OKTA_CLIENT_ID,
    issuer: OKTA_ISSUER,
    redirectUri: OKTA_REDIRECT_URL,
    scopes: ['openid', 'offline_access'],
    pkce: true,
    testing: {
      disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    },
    services: {
      autoRenew: false,
    },
    tokenManager: {
      autoRenew: false,
      autoRemove: false,
    },
  },
};




// WEBPACK FOOTER //
// ./src/okta-config.js